(function() {
  var preguntas = [
    {
      id: 'p1',
      texto: '¿Cómo te gustaría sentirte cuando percibas tu aroma?',
      opciones: [
        'En calma y relajada',
        'Con energía y buen ánimo',
        'Con claridad y concentración',
        'Arropada y confortable',
        'Fresca y revitalizada',
        'En un ambiente íntimo y especial',
        'Con sensación de limpieza y orden',
        'Rodeada de elegancia y sofisticación'
      ],
      mapa: {
        'En calma y relajada':                    'Calma y relajación',
        'Con energía y buen ánimo':               'Energía y ánimo',
        'Con claridad y concentración':           'Claridad y concentración',
        'Arropada y confortable':                 'Confort y acogimiento',
        'Fresca y revitalizada':                  'Frescura y limpieza',
        'En un ambiente íntimo y especial':       'Sensualidad e intimidad',
        'Con sensación de limpieza y orden':      'Limpieza y orden',
        'Rodeada de elegancia y sofisticación':   'Elegancia y sofisticación'
      }
    },
    {
      id: 'p2',
      texto: '¿En qué momento quieres disfrutarlo principalmente?',
      opciones: [
        'Al comenzar el día',
        'Mientras trabajo o estudio',
        'Después de limpiar o ventilar la casa',
        'Al llegar a casa y desconectar',
        'Durante un momento de lectura, descanso o autocuidado',
        'Cuando recibo visitas o quiero crear un ambiente especial'
      ],
      mapa: {
        'Al comenzar el día':                                              'Activación',
        'Mientras trabajo o estudio':                                      'Concentración',
        'Después de limpiar o ventilar la casa':                           'Hogar limpio',
        'Al llegar a casa y desconectar':                                  'Desconexión',
        'Durante un momento de lectura, descanso o autocuidado':           'Relax',
        'Cuando recibo visitas o quiero crear un ambiente especial':       'Ambiente especial'
      }
    },
    {
      id: 'p3',
      texto: '¿Qué tipo de aromas disfrutas más?',
      subtexto: 'Puedes elegir hasta 2.',
      opciones: [
        'Limpios, frescos y aireados',
        'Cítricos, frescos y luminosos',
        'Florales, suaves y delicados',
        'Verdes, herbales y naturales',
        'Frutales, jugosos y alegres',
        'Dulces, cremosos y golosos',
        'Amaderados, cálidos y envolventes',
        'Marinos, frescos y acuáticos',
        'Especiados, cálidos y con carácter'
      ],
      mapa: {
        'Limpios, frescos y aireados':        'Limpia',
        'Cítricos, frescos y luminosos':      'Cítrica',
        'Florales, suaves y delicados':       'Floral',
        'Verdes, herbales y naturales':       'Herbal',
        'Frutales, jugosos y alegres':        'Afrutada',
        'Dulces, cremosos y golosos':         'Dulce/Gourmand',
        'Amaderados, cálidos y envolventes':  'Amaderada',
        'Marinos, frescos y acuáticos':       'Marina',
        'Especiados, cálidos y con carácter': 'Especiada'
      },
      maxSelecciones: 2
    },
    {
      id: 'p4',
      texto: '¿Qué intensidad prefieres?',
      opciones: [
        'Suave y discreta',
        'Equilibrada',
        'Intensa y con presencia'
      ],
      mapa: {
        'Suave y discreta':        'Suave',
        'Equilibrada':             'Media',
        'Intensa y con presencia': 'Intensa'
      }
    },
    {
      id: 'p5',
      texto: '¿Cuál de estos caracteres olfativos te atrae más?',
      opciones: [
        'Fresco y mentolado',
        'Fresco y aéreo',
        'Floral suave',
        'Floral intenso',
        'Herbal y aromático',
        'Cítrico y luminoso',
        'Dulce y cremoso',
        'Amaderado y cálido',
        'Especiado y con carácter'
      ],
      mapa: {
        'Fresco y mentolado':        'fresco_mentolado',
        'Fresco y aéreo':            'fresco_aereo',
        'Floral suave':              'floral_suave',
        'Floral intenso':            'floral_intenso',
        'Herbal y aromático':        'herbal_aromatico',
        'Cítrico y luminoso':        'citrico_luminoso',
        'Dulce y cremoso':          'dulce_cremoso',
        'Amaderado y cálido':       'amaderado_calido',
        'Especiado y con carácter': 'especiado_caracter'
      }
    }
  ];

  var maticesEquivalentes = {
    'Limpia':         ['Limpia','Jabonosa','Algodonada'],
    'Cítrica':        ['Cítrica'],
    'Floral':         ['Floral'],
    'Herbal':         ['Herbal','Aromática','Verde'],
    'Afrutada':       ['Afrutada'],
    'Dulce/Gourmand': ['Dulce','Cremosa','Avainillada','Golosa'],
    'Amaderada':      ['Amaderada'],
    'Marina':         ['Acuosa','Marina'],
    'Especiada':      ['Especiada']
  };

  var caracterP5 = {
    'LF-002': ['dulce_cremoso',      'fresco_aereo'],
    'LF-003': ['citrico_luminoso',   null],
    'LF-004': ['fresco_mentolado',   'herbal_aromatico'],
    'LF-005': ['dulce_cremoso',      null],
    'LF-006': ['fresco_aereo',       'citrico_luminoso'],
    'LF-007': ['fresco_aereo',       'herbal_aromatico'],
    'LF-008': ['floral_intenso',     'amaderado_calido'],
    'LF-009': ['amaderado_calido',   'especiado_caracter'],
    'LF-010': ['floral_intenso',     'amaderado_calido'],
    'LF-011': ['floral_suave',       'fresco_aereo'],
    'LF-012': ['floral_suave',       'herbal_aromatico'],
    'LF-013': ['citrico_luminoso',   'fresco_aereo'],
    'LF-014': ['floral_intenso',     'citrico_luminoso'],
    'LF-015': ['herbal_aromatico',   'floral_suave'],
    'LF-016': ['floral_suave',       'fresco_aereo'],
    'LF-017': ['especiado_caracter', 'citrico_luminoso'],
    'LF-018': ['fresco_aereo',       null],
    'LF-019': ['fresco_aereo',       null],
    'LF-020': ['floral_suave',       'fresco_aereo'],
    'LF-021': ['fresco_mentolado',   null],
    'LF-022': ['floral_intenso',     null],
    'LF-023': ['fresco_mentolado',   null],
    'LF-024': ['herbal_aromatico',   null],
    'LF-025': ['floral_suave',       'dulce_cremoso'],
    'LF-026': ['fresco_aereo',       'floral_suave'],
    'LF-027': ['citrico_luminoso',   null],
    'LF-028': ['amaderado_calido',   'fresco_aereo'],
    'LF-029': ['citrico_luminoso',   'dulce_cremoso'],
    'LF-030': ['dulce_cremoso',      null],
    'LF-031': ['fresco_aereo',       null],
    'LF-032': ['floral_suave',       'citrico_luminoso'],
    'LF-033': ['amaderado_calido',   'especiado_caracter'],
    'LF-034': ['citrico_luminoso',   'floral_suave'],
    'LF-035': ['dulce_cremoso',      'fresco_mentolado'],
    'LF-036': ['fresco_mentolado',   null],
    'LF-037': ['fresco_aereo',       'floral_suave'],
    'LF-038': ['floral_intenso',     'especiado_caracter']
  };

  var intensidadOrden = { 'Suave': 0, 'Media': 1, 'Intensa': 2 };

  var currentStep = 0;
  var respuestas = {};

  var styleNormal   = 'display:inline-block;padding:10px 20px;border:1px solid #ccc;background:#fff;cursor:pointer;font-size:13px;letter-spacing:0.04em;border-radius:2px;color:#1a1a1a;margin:0;white-space:normal;text-align:center;line-height:1.4;';
  var styleSelected = 'display:inline-block;padding:10px 20px;border:1px solid #1a1a1a;background:#1a1a1a;cursor:pointer;font-size:13px;letter-spacing:0.04em;border-radius:2px;color:#fff;margin:0;white-space:normal;text-align:center;line-height:1.4;';

  function valorP1() { return preguntas[0].mapa[respuestas.p1] || null; }
  function valorP2() { return preguntas[1].mapa[respuestas.p2] || null; }
  function valoresP3() {
    var sels = respuestas.p3 || [];
    return sels.map(function(s) { return preguntas[2].mapa[s] || null; }).filter(Boolean);
  }
  function valorP4() { return preguntas[3].mapa[respuestas.p4] || null; }
  function valorP5() { return preguntas[4] && preguntas[4].mapa[respuestas.p5] || null; }

  function tieneMatiz(aroma, familia) {
    var equivalentes = maticesEquivalentes[familia] || [];
    if (!Array.isArray(aroma.matices)) return false;
    for (var i = 0; i < aroma.matices.length; i++) {
      if (equivalentes.indexOf(aroma.matices[i]) !== -1) return true;
    }
    return false;
  }

  function calcularPuntuacion(aroma) {
    var score = 0;
    var p1val  = valorP1();
    var p2val  = valorP2();
    var p3vals = valoresP3();
    var p4val  = valorP4();

    if (p1val) {
      if (aroma.perfil_principal === p1val) score += 5;
      else if (aroma.perfil_secundario === p1val) score += 2;
    }

    if (p2val && Array.isArray(aroma.momento_de_uso) && aroma.momento_de_uso.indexOf(p2val) !== -1) score += 3;

    if (p3vals.length === 1) {
      if (aroma.familia === p3vals[0]) score += 3;
      else if (tieneMatiz(aroma, p3vals[0])) score += 1;
    } else if (p3vals.length === 2) {
      for (var i = 0; i < 2; i++) {
        if (aroma.familia === p3vals[i]) score += 1.5;
        else if (tieneMatiz(aroma, p3vals[i])) score += 0.5;
      }
    }

    if (p4val && aroma.intensidad === p4val) score += 1;

    return score;
  }

  function calcularDesempate(aroma) {
    var p1val  = valorP1();
    var p2val  = valorP2();
    var p3vals = valoresP3();
    var p4val  = valorP4();

    var criterios = 0;
    if (p1val && (aroma.perfil_principal === p1val || aroma.perfil_secundario === p1val)) criterios++;
    if (p2val && Array.isArray(aroma.momento_de_uso) && aroma.momento_de_uso.indexOf(p2val) !== -1) criterios++;
    if (p3vals.length > 0) {
      var p3coincide = false;
      for (var i = 0; i < p3vals.length; i++) {
        if (aroma.familia === p3vals[i] || tieneMatiz(aroma, p3vals[i])) { p3coincide = true; break; }
      }
      if (p3coincide) criterios++;
    }
    if (p4val && aroma.intensidad === p4val) criterios++;

    var pp    = (p1val && aroma.perfil_principal === p1val) ? 1 : 0;
    var mom   = (p2val && Array.isArray(aroma.momento_de_uso) && aroma.momento_de_uso.indexOf(p2val) !== -1) ? 1 : 0;
    var fam   = (p3vals.length > 0 && aroma.familia === p3vals[0]) ? 1 : 0;
    var intens = (p4val && aroma.intensidad === p4val) ? 1 : 0;
    var ps    = (p1val && aroma.perfil_secundario === p1val) ? 1 : 0;

    return [criterios, pp, mom, fam, intens, ps];
  }

  function actualizarNav() {
    var p = preguntas[currentStep];
    var seleccionado = p.id === 'p3'
      ? (respuestas.p3 && respuestas.p3.length > 0)
      : !!respuestas[p.id];
    var prevBtn   = document.getElementById('test-aroma-prev');
    var nextBtn   = document.getElementById('test-aroma-next');
    var submitBtn = document.getElementById('test-aroma-submit');
    if (prevBtn)   prevBtn.setAttribute('style',   (currentStep > 0 ? 'display:inline-block;' : 'display:none!important;') + 'padding:12px 28px;font-size:12px;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;border:1px solid #ccc;background:#fff;color:#1a1a1a;border-radius:2px;');
    if (nextBtn)   nextBtn.setAttribute('style',   (currentStep < preguntas.length - 1 && seleccionado ? 'display:inline-block;' : 'display:none!important;') + 'padding:12px 28px;font-size:12px;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;border:1px solid #1a1a1a;background:#1a1a1a;color:#fff;border-radius:2px;');
    if (submitBtn) submitBtn.setAttribute('style', (currentStep === preguntas.length - 1 && seleccionado ? 'display:inline-block;' : 'display:none!important;') + 'padding:12px 28px;font-size:12px;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;border:1px solid #1a1a1a;background:#1a1a1a;color:#fff;border-radius:2px;');
  }

  function mostrarPregunta(index) {
    var welcomeEl  = document.getElementById('test-aroma-welcome');
    var p          = preguntas[index];
    var progressEl = document.getElementById('test-aroma-progress');
    var questionEl = document.getElementById('test-aroma-question');
    var optsEl     = document.getElementById('test-aroma-options');
    var navEl      = document.getElementById('test-aroma-nav');

    if (welcomeEl)  welcomeEl.style.display  = 'none';
    if (progressEl) progressEl.style.display = 'block';
    if (questionEl) questionEl.style.display = 'block';
    if (navEl)      navEl.style.display      = 'flex';

    if (progressEl) progressEl.innerHTML = 'Pregunta ' + (index + 1) + ' de ' + preguntas.length;

    var subtextoHTML = p.subtexto
      ? '<p style="font-size:13px;color:#999;margin:0 0 20px;letter-spacing:0.02em;">' + p.subtexto + '</p>'
      : '';
    if (questionEl) questionEl.innerHTML =
      '<h2 style="font-size:clamp(16px,2.5vw,24px);font-weight:400;letter-spacing:0.04em;max-width:600px;line-height:1.3;margin-bottom:12px;">' + p.texto + '</h2>' +
      subtextoHTML;

    if (optsEl) {
      optsEl.setAttribute('style', 'display:flex;flex-wrap:wrap;gap:10px;margin-bottom:8px;');
      optsEl.innerHTML = '';

      if (p.id === 'p3') {
        var seleccionadas = respuestas.p3 || [];
        p.opciones.forEach(function(op) {
          var btn = document.createElement('button');
          btn.textContent = op;
          btn.className = 'test-aroma-opcion';
          btn.setAttribute('style', seleccionadas.indexOf(op) !== -1 ? styleSelected : styleNormal);
          btn.addEventListener('click', function() {
            var idx = seleccionadas.indexOf(op);
            if (idx !== -1) {
              seleccionadas.splice(idx, 1);
              btn.setAttribute('style', styleNormal);
            } else {
              if (seleccionadas.length < 2) {
                seleccionadas.push(op);
                btn.setAttribute('style', styleSelected);
              }
            }
            respuestas.p3 = seleccionadas.slice();
            actualizarNav();
          });
          optsEl.appendChild(btn);
        });
      } else {
        p.opciones.forEach(function(op) {
          var btn = document.createElement('button');
          btn.textContent = op;
          btn.className = 'test-aroma-opcion';
          btn.setAttribute('style', respuestas[p.id] === op ? styleSelected : styleNormal);
          btn.addEventListener('click', function() {
            var allBtns = document.querySelectorAll('.test-aroma-opcion');
            for (var i = 0; i < allBtns.length; i++) allBtns[i].setAttribute('style', styleNormal);
            btn.setAttribute('style', styleSelected);
            respuestas[p.id] = op;
            actualizarNav();
          });
          optsEl.appendChild(btn);
        });
      }
    }
    actualizarNav();
  }

  function mostrarBienvenida() {
    var welcomeEl  = document.getElementById('test-aroma-welcome');
    var progressEl = document.getElementById('test-aroma-progress');
    var questionEl = document.getElementById('test-aroma-question');
    var optsEl     = document.getElementById('test-aroma-options');
    var navEl      = document.getElementById('test-aroma-nav');
    if (progressEl) progressEl.style.display = 'none';
    if (questionEl) questionEl.style.display = 'none';
    if (optsEl)     optsEl.style.display     = 'none';
    if (navEl)      navEl.style.display      = 'none';
    if (welcomeEl)  welcomeEl.style.display  = 'block';
  }

  function construirBotones(productos) {
    if (!productos || productos.length === 0) return '';
    return '<div class="test-aroma-formatos">' +
      productos.map(function(p) {
        return '<a href="' + p.url + '" class="test-aroma-formato-btn" target="_blank" rel="noopener">' + p.titulo + '</a>';
      }).join('') +
      '</div>';
  }

      function mostrarResultados() {
    var aromas = window.aromasData || [];
    var puntuados = aromas.map(function(a) {
      return { aroma: a, score: calcularPuntuacion(a) };
    });

    puntuados.sort(function(a, b) {
      if (b.score !== a.score) return b.score - a.score;

      var da = calcularDesempate(a.aroma);
      var db = calcularDesempate(b.aroma);
      for (var i = 0; i < da.length; i++) {
        if (db[i] !== da[i]) return db[i] - da[i];
      }

      var p5val = valorP5();
      var p5a = 0, p5b = 0;
      if (p5val) {
        var ca5 = caracterP5[a.aroma.codigo] || [null, null];
        var cb5 = caracterP5[b.aroma.codigo] || [null, null];
        p5a = (ca5[0] === p5val) ? 2 : (ca5[1] === p5val) ? 1 : 0;
        p5b = (cb5[0] === p5val) ? 2 : (cb5[1] === p5val) ? 1 : 0;
      }
      if (p5b !== p5a) return p5b - p5a;

      var p4val = valorP4();
      var proxA = 0, proxB = 0;
      if (p4val) {
        proxA = 2 - Math.abs((intensidadOrden[a.aroma.intensidad] || 0) - (intensidadOrden[p4val] || 0));
        proxB = 2 - Math.abs((intensidadOrden[b.aroma.intensidad] || 0) - (intensidadOrden[p4val] || 0));
      }
      if (proxB !== proxA) return proxB - proxA;

      var p2val = valorP2();
      var espA = 0, espB = 0;
      if (p2val) {
        var momA = Array.isArray(a.aroma.momento_de_uso) && a.aroma.momento_de_uso.indexOf(p2val) !== -1;
        var momB = Array.isArray(b.aroma.momento_de_uso) && b.aroma.momento_de_uso.indexOf(p2val) !== -1;
        if (momA) espA = -a.aroma.momento_de_uso.length;
        if (momB) espB = -b.aroma.momento_de_uso.length;
      }
      if (espB !== espA) return espB - espA;

      var cna = parseInt((a.aroma.codigo || '').replace('LF-', ''), 10);
      var cnb = parseInt((b.aroma.codigo || '').replace('LF-', ''), 10);
      return cna - cnb;
    });

    var top3 = puntuados.slice(0, 3);

    // Guardar resultado en localStorage
    try {
      localStorage.setItem('lfe_test_resultado', JSON.stringify({
        top3: top3.map(function(item) {
          return {
            nombre: item.aroma.nombre,
            descripcion: item.aroma.descripcion || '',
            codigo: item.aroma.codigo,
            productos: item.aroma.productos || []
          };
        })
      }));
    } catch(e) {}

    var questionEl = document.getElementById('test-aroma-question');
    var optsEl     = document.getElementById('test-aroma-options');
    var navEl      = document.getElementById('test-aroma-nav');
    var progressEl = document.getElementById('test-aroma-progress');
    var resEl      = document.getElementById('test-aroma-results');

    if (questionEl) questionEl.style.display = 'none';
    if (optsEl)     optsEl.style.display     = 'none';
    if (navEl)      navEl.style.display      = 'none';
    if (progressEl) progressEl.style.display = 'none';

    if (resEl) {
      resEl.style.display = 'block';
      renderizarResultados(resEl, top3);
    }
  }

  function renderizarResultados(resEl, top3) {
    var tarjetas = top3.map(function(item, i) {
      var productos = item.aroma.productos || [];
      var botonesHTML = productos.length > 0
        ? '<div class="test-aroma-formatos">' +
          productos.map(function(p) {
            var url = p.url + (p.url.indexOf('?') === -1 ? '?' : '&') + 'from=test-aroma';
                        return '<a href="' + url + '" class="test-aroma-formato-btn" target="_blank" rel="noopener">' + p.titulo + '</a>';
          }).join('') +
          '</div>'
        : '';

      if (i === 0) {
        return '<div class="test-aroma-resultado test-aroma-resultado--principal">' +
          '<p class="test-aroma-resultado-label">Tu aroma ideal</p>' +
          '<h3>' + item.aroma.nombre + '</h3>' +
          '<p class="test-aroma-resultado-desc">' + (item.aroma.descripcion || '') + '</p>' +
          botonesHTML +
          '</div>';
      } else {
        return '<div class="test-aroma-resultado test-aroma-resultado--secundario">' +
          '<h3>' + item.aroma.nombre + '</h3>' +
          '<p class="test-aroma-resultado-desc">' + (item.aroma.descripcion || '') + '</p>' +
          botonesHTML +
          '</div>';
      }
    });
           var bloqueAccion = '<div class="test-aroma-cta" style="margin-top:32px;text-align:center;"><p style="margin:0;"><a href="javascript:void(0)" id="test-aroma-reiniciar" style="font-size:12px;color:#999;letter-spacing:0.06em;text-decoration:underline;cursor:pointer;">Volver a hacer el test</a></p></div>';
    resEl.innerHTML = '<div class="test-aroma-resultados-grid">' + tarjetas.join('') + '</div>' + bloqueAccion;



    
     

    var reiniciarBtn = document.getElementById('test-aroma-reiniciar');
    if (reiniciarBtn) {
      reiniciarBtn.addEventListener('click', function() {
        try { localStorage.removeItem('lfe_test_resultado'); } catch(e) {}
        currentStep = 0;
        respuestas = {};
        resEl.style.display = 'none';
        mostrarBienvenida();
      });
    }
  }



  document.addEventListener('DOMContentLoaded', function() {
    if (!document.getElementById('test-aroma-container')) return;

        // Restaurar resultado si viene de una ficha de producto
    var resultadoGuardado = null;
    try { resultadoGuardado = JSON.parse(localStorage.getItem('lfe_test_resultado')); } catch(e) {}

        if (resultadoGuardado && resultadoGuardado.top3 && window.location.search.indexOf('restaurar=1') !== -1) {A
      var resEl = document.getElementById('test-aroma-results');
      if (resEl) {
        resEl.style.display = 'block';
        renderizarResultados(resEl, resultadoGuardado.top3.map(function(a) { return { aroma: a }; }));
      }
    } else {
      mostrarBienvenida();
    }


    var startBtn  = document.getElementById('test-aroma-start');
    var prevBtn   = document.getElementById('test-aroma-prev');
    var nextBtn   = document.getElementById('test-aroma-next');
    var submitBtn = document.getElementById('test-aroma-submit');

    if (startBtn) startBtn.addEventListener('click', function() {
      currentStep = 0;
      respuestas = {};
      mostrarPregunta(0);
    });
    if (prevBtn) prevBtn.addEventListener('click', function() {
      if (currentStep > 0) { currentStep--; mostrarPregunta(currentStep); }
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      if (currentStep < preguntas.length - 1) { currentStep++; mostrarPregunta(currentStep); }
    });
    if (submitBtn) submitBtn.addEventListener('click', function() {
      mostrarResultados();
    });
  });
})();
